// export UploadDesignImg from "./uploadDesignImg";

export const UploadDesignImg = dsf.defineAsyncComponent("DsfUploadDesignImg", () =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./uploadDesignImg.vue")
);
